import { IdoButton } from 'src/models/ido';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheIdoButtonForAnAggregateIdQueryCallback extends Callback<IdoButton> {
	public constructor(
		private readonly resolveIdoButton: (idoButton: IdoButton) => void,
		private readonly resolveFailure: () => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.resolveFailure();
	};

	successCallbackFunction = (successResponse: IdoButton): void => {
		this.resolveIdoButton(successResponse);
	};
}
